var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "textual_menu--container page-content",
      class: _vm.containerClasses,
      style: _vm.containerStyles,
      attrs: { tabindex: "-1" },
    },
    [
      _c("search-menu", {
        ref: "search",
        attrs: {
          "search-index": _vm.searchIndex,
          "search-key": _vm.searchKey,
          "search-host": _vm.searchHost,
          menu: _vm.menu,
          "related-menus": _vm.relatedMenus,
          "is-cart-enabled": _vm.isCartEnabled,
          "minimize-widget": "",
        },
        on: {
          "view-menu-item": function ($event) {
            return _vm.scrollToMenuItem($event)
          },
          "toggle-menu-item-favorite": function ($event) {
            return _vm.$store.commit("toggleMenuItemSelected", [
              $event,
              _vm.menu?.menu_id || 0,
            ])
          },
        },
      }),
      _vm._v(" "),
      _c("menu-switcher", {
        ref: "switcher",
        attrs: {
          menus: _vm.allRelatedMenus,
          "current-menu-id": _vm.currentMenuId,
          "device-asset-code": _vm.deviceAssetCode,
        },
        on: { opened: _vm.closeSearchMenu },
      }),
      _vm._v(" "),
      _c("h1", { ref: "title" }, [
        _vm.menu
          ? _c("span", [_vm._v(_vm._s(_vm.menu.full_title) + " ")])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isCartEnabled
        ? _c("a", {
            staticClass:
              "item_button--container item_button--container-cart material-icons textual_menu--glass_effect",
            class: {
              "item_button--container-active": _vm.showSelectedMenuItems,
            },
            attrs: { href: "#", title: "Click to view your saved items" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.showSelectedMenuItems = !_vm.showSelectedMenuItems
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.menu && _vm.menu.menu_content_area_top.length
        ? _c(
            "div",
            {
              staticClass:
                "body-container no-images show-all-items textual_menu--section",
            },
            [
              _c(
                "div",
                {
                  staticClass: "page-link-group-copy page-link-group-copy-top",
                },
                [
                  _c("div", {
                    staticClass: "viewport",
                    domProps: {
                      innerHTML: _vm._s(_vm.menu.menu_content_area_top),
                    },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.menu
        ? _vm._l(_vm.menu.sections, function (section) {
            return _c("section-dispatch", {
              key: "section-" + section.ms_id,
              ref: "section--" + section.ms_id,
              refInFor: true,
              attrs: {
                section: section,
                menu: _vm.menu,
                "display-type": "textual",
              },
            })
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.menu && _vm.menu.menu_content_area_bottom.length
        ? _c(
            "div",
            {
              staticClass:
                "body-container no-images show-all-items textual_menu--section",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "page-link-group-copy page-link-group-copy-bottom",
                },
                [
                  _c("div", {
                    staticClass: "viewport",
                    domProps: {
                      innerHTML: _vm._s(_vm.menu.menu_content_area_bottom),
                    },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.menu?.menu_version?.length
        ? _c("menu-version", { attrs: { version: _vm.menu.menu_version } })
        : _vm._e(),
      _vm._v(" "),
      _vm.sectionsForNav.length
        ? _c("menu-section-list-v2", {
            ref: "footer",
            attrs: { "initial-section": _vm.initialSection, menu: _vm.menu },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.isAdminView && _vm.menu
        ? _c("menu-schedules", {
            attrs: {
              "normalized-schedules": _vm.menu?.normalizedSchedules,
              "is-fixed": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("loader", {
        ref: "loader",
        attrs: { active: _vm.isLoading },
        nativeOn: {
          click: function ($event) {
            _vm.isLoading = false
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }